import { modalBodyLock, modalBodyLockClear } from './bodyLock.js';

export const diseasesAndConditionsSearch = () => {
    const diseasesButton = document.getElementById('diseases-button');

    if (!diseasesButton) {
        return;
    }

    const allButton = document.getElementById('all-button');

    const diseaseOrConditionChoiceButtons = document.getElementsByClassName(
        'disease-or-condition-choice'
    );

    const queryButton = document.getElementById(
        'disease-or-condition-query-button'
    );

    const searchInputField = document.getElementById(
        'disease-or-condition-query'
    );

    const alphabetContainer = document.getElementsByClassName(
        'inner-alphabet-sticky-top'
    );

    function debounce(callback, wait) {
        let timeout;
        return (...args) => {
            clearTimeout(timeout);
            timeout = setTimeout(function () {
                callback.apply(this, args);
            }, wait);
        };
    }

    function getUrlParameter(sParam) {
        const sPageUrl = window.location.search.substring(1);
        const sUrlVariables = sPageUrl.split('&');
        let sParameterName;
        let i;

        for (i = 0; i < sUrlVariables.length; i++) {
            sParameterName = sUrlVariables[i].split('=');

            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined
                    ? true
                    : decodeURIComponent(sParameterName[1]);
            }
        }

        return undefined;
    }

    function getData(event) {
        // Reset the buttons
        if (diseaseOrConditionChoiceButtons) {
            Array.from(diseaseOrConditionChoiceButtons).forEach((element) => {
                element.classList.remove('dark');
            });
        }

        // Get the input values.
        let showFromButtonClick = '';
        let showFromQueryString = '';
        let searchStringFromInputField = '';
        let searchStringFromQueryString = '';

        let show = '';
        let searchString = '';

        if (
            event &&
            event.target.classList.contains('disease-or-condition-choice')
        ) {
            showFromButtonClick = event.target.dataset.show;
        }

        if (
            event &&
            event.target.classList.contains(
                'disease-or-condition-query-input'
            ) &&
            searchInputField &&
            searchInputField.value
        ) {
            searchStringFromInputField = searchInputField.value;
        }

        if (!event) {
            showFromQueryString = getUrlParameter('show');
            searchStringFromQueryString = getUrlParameter('searchstring');
        }

        // Set the state.
        if (showFromButtonClick) {
            show = showFromButtonClick;
            event.target.classList.add('dark');
            searchInputField.value = '';
            searchString = '';
        }

        if (showFromQueryString) {
            show = showFromQueryString;

            const buttonName = `${show}-button`;

            const buttonToActivate = document.getElementById(buttonName);
            buttonToActivate.classList.add('dark');
        }

        if (searchStringFromInputField) {
            searchString = searchStringFromInputField;
        }

        if (!event && searchStringFromQueryString) {
            searchString = searchStringFromQueryString;
            searchInputField.value = searchStringFromQueryString;
        }

        if (!show && !searchString) {
            show = 'all';
        }

        if (searchString) {
            show = 'all';
        }

        if (show === 'all') {
            allButton.classList.add('dark');
        }

        const url = `/partials/diseasesandconditionslist?show=${show}&searchstring=${searchString}`;
        const queryString = url.split('?')[1];

        const baseLocation = window.location.href.split('?')[0];
        const windowUrl = `${baseLocation}?${queryString}${window.location.hash}`;

        window.history.replaceState(null, null, windowUrl);

        // eslint-disable-next-line no-undef
        $.ajax({
            type: 'GET',
            url,
            data: queryString,
            success(data) {
                const parser = new DOMParser();
                const htmlDoc = parser.parseFromString(data, 'text/html');

                const alphabetList = htmlDoc.getElementById('alphabet-list');
                const itemList = htmlDoc.getElementById('item-list');

                $('#content-target').html(itemList.innerHTML);
                $('#alphabet-target').html(alphabetList);
            },
        });
    }

    // Set up events.

    document.addEventListener('focusin', function (e) {
        if (e.target.classList.contains('filter-btn')) {
            if (alphabetContainer) {
                alphabetContainer[0].classList.remove('sticky-hidden-top');
            }
        }
    });

    document.addEventListener('click', function (e) {
        const anchor = e.target.closest('a[href^="#"]');

        if (anchor) {
            e.preventDefault();

            const href = document.querySelector(anchor.getAttribute('href'));

            if (href) {
                //href.scrollIntoView({ behavior: "smooth", block: "start", inline: "start" });

                // Set the focus to the first link in this letter group.

                const firstLink = $('div#' + href.id)
                    .find(':nth-of-type(2)')
                    .find('a:first');

                firstLink[0].focus();

                firstLink[0].scrollIntoView();

                window.scrollBy(0, -80);

                setTimeout(() => {
                    document
                        .querySelector('html')
                        .setAttribute('data-scrolldir', 'down');
                }, 1000);
            }
        }
    });

    if (diseaseOrConditionChoiceButtons) {
        Array.from(diseaseOrConditionChoiceButtons).forEach((element) => {
            element.addEventListener('click', getData);
        });
    }

    if (queryButton) {
        queryButton.addEventListener('click', getData);
    }

    if (searchInputField) {
        searchInputField.addEventListener(
            'keyup',
            debounce((event) => {
                getData(event);
            }, 600)
        );
    }

    // onLoad
    getData(null);
};
